import { Link } from 'react-router-dom';
import { RegionModel } from '@pages/sales-network/regions-clinics/RegionModel';



interface RegionProps {
	selectedRegion: string,
	region: RegionModel,
}


const Region = (props: RegionProps): JSX.Element | null => {
	const { selectedRegion } = props;
	const { name, region, clinics } = props.region;

	if (selectedRegion !== '' && selectedRegion !== region) return null;


	if (selectedRegion === '' && (!clinics || clinics.length === 0)) return null;


	if (selectedRegion === region && (!clinics || clinics.length === 0)) return (
		<div className='region-clinics'>
			<h2>{name}</h2>
			<p>seznam partnerských veterin:</p>
			
			<div className='clinics-list'>
				<p className='empty-link'>
					Bohužel, v tomto kraji nemáme žádné partnery.
				</p>
			</div>
		</div>
	)

	return (
		<div className='region-clinics'>

			<h2>{name}</h2>
			
			<div className='clinics-list'>

				{clinics.map(x =>
					<Link to={x.link}
						className='disable-selection'
						target='_blank'
						rel='noopener noreferrer'
						key={`slinics-list-${x.name}`}>
							{x.name}
					</Link>)}
			
			</div>
		</div>
	);
};

export default Region;